import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { BeaconSensorEvent } from "../api";
import { CsvColumn, useDownloadCsv } from "../util";

interface DownloadEnvironmentMessagesProps {
  style?: React.CSSProperties;
  beaconId: string;
  environmentMessages: BeaconSensorEvent[];
  from: Date;
  to: Date;
}

const columns: CsvColumn<BeaconSensorEvent>[] = [
  {
    title: "BeaconId",
    value: (_p, _c, i) => i,
  },
  {
    title: "MeasuredAt",
    value: (p, c) => p.ts.toLocaleString(c),
  },
  {
    title: "Batt",
    value: (p, c) => p.sensors?.batt.v?.toLocaleString(c),
  },
];

export function DownloadEnvironmentMessages(
  props: DownloadEnvironmentMessagesProps
) {
  const { t } = useTranslation();
  const { environmentMessages, from, to, beaconId } = props;
  const download = useDownloadCsv(
    beaconId,
    environmentMessages,
    columns,
    `EnvironmentMessages_${beaconId}_${from.toISOString()}_${to.toISOString()}.csv`
  );

  return (
    <div style={props.style}>
      <Button type="dashed" onClick={download}>
        {t("save-as-csv")}
      </Button>
    </div>
  );
}
